import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useState } from "react";
import { X } from "lucide-react";
import { useNeumorphicTheme } from "@/contexts/NeumorphicThemeContext";
import { cn } from "@/lib/utils";

const HeroSection = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  // Try to get theme, provide fallback for pages without provider
  let theme = "dark";
  try {
    const themeContext = useNeumorphicTheme();
    theme = themeContext.theme;
  } catch {
    // Not wrapped in provider, use default
  }

  const subtitleColor = cn("transition-colors duration-500", theme === "dark" ? "text-gray-300" : "text-gray-600");

  const buttonStyles = cn(
    "py-3 px-8 text-lg rounded-xl font-normal transition-all duration-500",
    theme === "dark"
      ? "bg-[#0a0a0a] text-white shadow-[6px_6px_12px_#000000,-6px_-6px_12px_#141414] hover:shadow-[8px_8px_16px_#000000,-8px_-8px_16px_#141414] hover:bg-[#141414]"
      : "bg-[#f5f5f5] text-[#1a1a1a] shadow-[4px_4px_8px_#d8d8d8,-4px_-4px_8px_#fefefe] hover:shadow-[6px_6px_10px_#d0d0d0,-6px_-6px_10px_#fefefe] hover:bg-[#ebebeb]"
  );

  return <>
      {/* Calendly Modal */}
      {showCalendly && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative w-full max-w-2xl h-[70vh] bg-white rounded-lg overflow-hidden shadow-xl">
            <button onClick={closeCalendlyModal} className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors">
              <X className="h-6 w-6 text-gray-600" />
            </button>
            <iframe src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" width="100%" height="100%" frameBorder="0" title="Schedule a meeting" />
          </div>
        </div>}

      <div className="w-full py-16 md:py-20">
        <div className="max-w-6xl mx-auto px-4 text-center py-0 my-[2px]">
          {/* Headline */}
          <h1 className="text-3xl md:text-5xl mb-6 leading-tight py-0 text-[#e4683b] font-light">
            Where Silicon Valley Innovation Meets Timeless Craftsmanship.
          </h1>
          
          {/* Subtitle */}
          <p className={cn("md:text-xl leading-relaxed max-w-4xl mx-auto mb-12 text-base", subtitleColor)}>
            At UDA ADU, we don't just add square footage.<br />
            We engineer strategic wealth through design-driven development, tailored for Bay Area homeowners who think like investors.
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center my-[2px] py-0">
            <Button onClick={openCalendlyModal} className={buttonStyles}>
              Book Your Complimentary Meeting
            </Button>
            <a href="https://udaadu.com/landing" target="_blank" rel="noopener noreferrer">
              <Button className={buttonStyles}>
                What Fits My Lot?
              </Button>
            </a>
            <Link to="/adu-calculator">
              <Button className={buttonStyles}>
                Get Your ROI Scorecard
              </Button>
            </Link>
            <Link to="/our-work">
              <Button className={buttonStyles}>
                View Our Portfolio
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </>;
};
export default HeroSection;